var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyGbp = function SvgIconCurrencyGbp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.754 4.75c.41-.002.815.078 1.192.235L12.748 2.75a5.125 5.125 0 0 0-5.123 5.125v3.5H5.25a1 1 0 1 0 0 2h2.375v2.75A2.375 2.375 0 0 1 5.25 18.5a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H8.924c.454-.702.701-1.526.701-2.375v-2.75h3.125a1 1 0 0 0 0-2H9.625v-3.5A3.125 3.125 0 0 1 12.75 4.75z"
  })));
};
export default SvgIconCurrencyGbp;